<div class="d-flex justify-content-center empty-card">
    <h2 class="mat-body m-0">Don’t fret! Click “NEW CREDIT CARD” to store your first payment method</h2>
</div>
